// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setFundChartEndDate } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/end-date/end-date.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const endDate = createReducer(null, on(setChartData, (state, { chartData }) => chartData.params.endDate), on(setFundChartEndDate, (state, { date }) => date));
